// src/AuthContext.js
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userDoc, setUserDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (!user) {
        setUserDoc(null);
        setLoading(false);
        return;
      }
      try {
        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);
        setUserDoc(snap.exists() ? snap.data() : null);
      } finally {
        setLoading(false);
      }
    });
    return () => unsub();
  }, []);

  const value = useMemo(() => {
    const role = userDoc?.role ?? null;
    const communities = userDoc?.communities ?? [];
    const primaryCommunityId = userDoc?.primaryCommunityId ?? communities[0] ?? null;

    return {
      loading,
      currentUser,
      role,
      isAdmin: role === "admin",
      isManager: role === "manager",
      isResident: role === "resident",
      communities,
      primaryCommunityId,
      userDoc,
    };
  }, [loading, currentUser, userDoc]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
